import React, {useEffect} from "react"

// Added to the global runtime by the script tag further down the file.
declare const docsearch: any | undefined



// Runs the new docsearch function over possible search inputs
const runDocsearchIfPossible = () => {
    if (typeof docsearch !== 'undefined') {
      const searches = ["algolia-search-input", "hero-search-input"]
      for (const searchID of searches) {
        if (!document.getElementById(searchID)) continue

        docsearch({
          apiKey: 'd103541f3e6041148aade2e746ed4d61',
          indexName: 'graphql',
          inputSelector: `#${searchID}`
        });
      }
    }
}

const Search = ({searchID}: { searchID?: string}): JSX.Element => {
  const searchInputID = searchID || "algolia-search-input"

  // This extra bit of mis-direction ensures that non-essential code runs after
  // the page is loaded
  useEffect(() => {
    runDocsearchIfPossible()

    if (document.getElementById("algolia-search")) return

    const searchScript = document.createElement('script');
    searchScript.id = "algolia-search"
    const searchCSS = document.createElement('link');

    searchScript.src = "https://cdn.jsdelivr.net/docsearch.js/1/docsearch.min.js";
    searchScript.async = true;
    searchScript.onload = () => {
      if (typeof docsearch !== 'undefined') {
        runDocsearchIfPossible()

        searchCSS.rel = 'stylesheet';
        searchCSS.href = 'https://cdn.jsdelivr.net/docsearch.js/1/docsearch.min.css'
        searchCSS.type = 'text/css';
        document.body.appendChild(searchCSS);
      }
    }

    document.body.appendChild(searchScript);
  }, []);


  return (
    <div className="algolia-search-wrapper">
      <input
        id={searchInputID}
        type="text"
        placeholder="搜索文档..."
        aria-label="搜索文档"
      />
    </div>
  )
}

export default Search
